import React, { useEffect, useMemo, useState } from "react";


const TeamPerformance =({ teams, selectedTeamId = "" }) =>{

    const [expandedTeams, setExpandedTeams] = useState({});

    function StatCell({ value }) {
        return <td>{value ?? "-"}</td>;
    }



  const filteredTeams = useMemo(() => {
    if (!selectedTeamId) return teams;
    return teams.filter((team) => team.teamId === selectedTeamId);
  }, [teams, selectedTeamId]);

  const toggleTeam = (teamId) => {
    setExpandedTeams((prev) => ({
      ...prev,
      [teamId]: !prev[teamId],
    }));
  };



  return (
    <div className="crm-team-table-card">
      <div className="crm-team-table-header">
        <h3>Team Performance</h3>
      </div>

      <div className="crm-team-table-wrap">
        <table className="crm-team-table">
          <thead>
            <tr>
              <th>Teams</th>
              <th>Total Leads</th>
              <th>Fresh</th>
              <th>Warm</th>
              <th>Cold</th>
              <th>Dead</th>
              <th>Enrolled</th>
              <th>Conv %</th>
            </tr>
          </thead>

          <tbody>
            {filteredTeams.map((team, teamIndex) => {
              const isExpanded = !!expandedTeams[team.teamId];

              return (
                <React.Fragment key={team.teamId}>
                  <tr className="crm-team-row">
                    {/*<td>
                      <button
                        type="button"
                        className="crm-expand-btn"
                        onClick={() => toggleTeam(team.teamId)}
                        aria-label={isExpanded ? "Collapse team" : "Expand team"}
                      >
                        {isExpanded ? "−" : "+"}
                      </button>
                    </td>*/}

                    <td>
                      <div className="crm-team-name-wrap">
                        <div className="crm-team-avatar">
                          {team.teamName?.slice(0, 2).toUpperCase()}
                        </div>
                        <div>
                          <div className="crm-team-name">{team.tlName}</div>                          
                        </div>
                      </div>
                    </td>

                    <StatCell value={team.stats.totalLeads} />
                    <StatCell value={team.stats.fresh} />
                    <StatCell value={team.stats.warm} />
                    <StatCell value={team.stats.cold} />
                    <StatCell value={team.stats.dead} />
                    <StatCell value={team.stats.enrolled} />
                    <td className="crm-conv-cell">{team.stats.conversion}%</td>
                  </tr>

                  {/*isExpanded &&
                    team.callers.map((caller) => (
                      <tr
                        className="crm-caller-row"
                        key={`${team.teamId}_${caller.callerId}`}
                      >
                        <td></td>
                        <td>
                          <div className="crm-caller-name-wrap">
                            <span className="crm-caller-indent" />
                            <div>
                              <div className="crm-caller-name">
                                {caller.callerName}
                              </div>                              
                            </div>
                          </div>
                        </td>

                        <td>—</td>
                        <StatCell value={caller.stats.totalLeads} />
                        <StatCell value={caller.stats.fresh} />
                        <StatCell value={caller.stats.warm} />
                        <StatCell value={caller.stats.cold} />
                        <StatCell value={caller.stats.dead} />
                        <StatCell value={caller.stats.enrolled} />
                        <StatCell value={caller.stats.dueToday} />
                        <StatCell value={caller.stats.pending} />
                        <td className="crm-conv-cell">
                          {caller.stats.conversion}%
                        </td>
                      </tr>
                    ))*/}

                  {isExpanded && team.callers.length === 0 && (
                    <tr className="crm-caller-empty-row">
                      <td></td>
                      <td colSpan={11}>No callers found for this team.</td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

}

export default TeamPerformance;
